import { useState } from 'react';
import { i18n } from 'app/utils/i18n';

export function CopyVariable({ variableKey }: { variableKey: string }) {
  const [copied, setCopied] = useState(false);
  const text = `$${variableKey}`;

  const handleCopy = () => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-999999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <span className="d-inline-flex align-items-center gap-1">
      <code className="text-muted fs-7">{text}</code>
      <button
        className="btn btn-sm p-0 text-muted"
        onClick={handleCopy}
        title={copied ? i18n('common.copied') : i18n('common.copy')}
        style={{ fontSize: '0.7rem', lineHeight: 1 }}
      >
        <i className={`fa-regular ${copied ? 'fa-check' : 'fa-copy'}`} />
      </button>
    </span>
  );
}
